// extracted by mini-css-extract-plugin
export default {"offersPage":"styles_offersPage__6r6sB","offersWrapper":"styles_offersWrapper__dctEG"};